<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline xblock-row">
          <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
        </div>
        <div class="x-right xblock-row">
          <span class="x-right" v-text="'共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'总利息：'+statics.rebate+ '元　|　'"></span>
          <span class="x-right" v-text="'总投入：'+statics.total_money+ '元　|　'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>标题</th>
            <th>头像</th>
            <th>名称</th>
            <th>金额</th>
            <th>利息</th>
            <th>剩余天数</th>
            <th>投入时间</th>
            <th>入账时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index"
            :class="[{cancel_box:item.status == 1},{shipping_box:item.status == 2}]">
            <td v-text="item.batch_name"></td>
            <td>
              <div class="table_img">
                <img v-if="item.head_url && item.head_url != 'null'" :src="item.head_url">
                <img v-else src="../../../../static/images/avatar.png">
              </div>
            </td>
            <td v-text="item.name"></td>
            <td v-text="item.money"></td>
            <td v-text="item.rebate"></td>
            <td>
              <i v-if="item.date > 0" v-text="item.date"></i>
              <i v-else>已到期</i>
            </td>
            <td v-text="item.created_at"></td>
            <td v-text="item.handle_at"></td>
            <td class="btn-arr">
              <button class="layui-btn">详情</button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition v-if="list.length < 1"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage, laydate;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'MemberRechargeLog',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        money: 0,
        page_num: 20,
        current_status: 0,
        status_id: 0,
        list: [],
        statics: {
          rebate:0,
          total_money:0
        },
        status: [{
          id: 1,
          name: "未完成"
        }, {
          id: 2,
          name: "已完成"
        }]
      }
    },
    mounted() {
      self = this;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {

        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true
        });

        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status]").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }
          self.status_id = status; //获取当前站点
          self.get_recharge_record(true)
        });
        form.render('select');

        self.get_recharge_record()
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      get_recharge_record() {
        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
          self.getDate(t, function(s, e) {
            start_time = s;
            end_time = e;
          })
        }

        self.loading = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        if (start_time) {
          param.append('start_time', start_time)
        }
        if (end_time) {
          param.append('end_time', end_time)
        }

        param.append('status', self.status_id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/admin_financing_log_list/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.count = datas.page.count;

            var list = datas.list;
            var statics = datas.statics;
            for(let i in list){
              list[i].total = (list[i].money * (1+list[i].rebate*0.01)).toFixed(2);
              list[i].income = (list[i].money * (list[i].rebate*0.01)).toFixed(2);
              var s2 = list[i].handle_at,s1;
              s1 = new Date();//当前日期：2017-04-24
              s2 = new Date(s2.replace(/-/g, "/"));
              var days = s2.getTime() - s1.getTime();
              var time = parseInt(days / (1000 * 60 * 60 * 24));
              list[i].date = time;
            }
            self.list = list;
            self.statics = statics;
            self.money = datas.money;
            self.ShowPage(self, laypage, "get_recharge_record"); //分页
            $('.pagebox').show();
            console.log("触发")
          }, false);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .table_img {
    width: 60px !important;
    height: 60px !important;
    border-radius: 100px;
  }

  .country_select {
    width: 150px;
  }

  .total-data {
    padding: 12px 10px;
    line-height: 18px;
  }

  .total-data-row {
    color: #444;
    padding-right: 30px;
    margin-right: 30px;
    border-right: 1px solid #CCC;
    font-family: Microsoft YaHei, arial;
    font-family: arial;
    font-size: 15px;
  }

  .total-data-row:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/finance/Invest.vue